<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<router-link tag="button" :to="{name: 'leads.status.create'}" class="btn btn-info">
                    <span class="btn-label">
                        <i class="material-icons">add</i>
                    </span>
					Novo
				</router-link>
			</div>
		</div>
		<br />
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-icon card-header-rose">
						<div class="card-icon">
							<i class="material-icons">list</i>
						</div>
						<h4 class="card-title ">Lista</h4>
					</div>
					<div class="card-body">
						<div class="table-responsive">
							<table class="table">
								<thead>
								<tr>
									<th class="text-center">#</th>
									<th>Nome</th>
									<th>Dias</th>
									<th>Desabilita Lead</th>
									<th style="width: 50px">Cor</th>
									<th class="text-right">Ações</th>
								</tr>
								</thead>
								<tbody>
								<tr
										v-show="items.length > 0"
										v-for="iterator in items"
										:key="iterator.id">
									<td class="text-center">{{ iterator.id }}</td>
									<td>{{ iterator.status }}</td>
									<td>{{ iterator.term}} dias</td>
									<td>{{ iterator.disable_lead == 1 ? 'Sim' : 'Não'}}</td>
									<td style="width: 50px"><div :style="{'background-color': iterator.color}" style="border: 1px solid rgba(0,0,0,0.2);width: 30px; height: 30px;border-radius: 50%"></div></td>
									<td class="td-actions text-right">
										<index-buttons
												:iterator=iterator
												:showAudit="false"
												:showEdit="showEdit(iterator)"
												:toEdit="{name: 'leads.status.edit', params: { id: iterator.id }}"
												:showRemove="showRemove(iterator)"
												dispatchRemove="lead_status/rem"
												:callbackRemove="getData">
										</index-buttons>
									</td>
								</tr>
								<tr v-show="items.length==0">
									<td colspan="5">Nenhuma equipe encontrada!</td>
								</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
    export default {
        computed: {
            items: {
                set(_itens) {
                    this.$store.commit('lead_status/setList', []);
                },
                get(){
                    return this.$store.state.lead_status.itens;
                }
            }

        },
        created: function () {
            this.items = [];
            this.getData();
        },
        methods: {
            async getData() {
                var self = this;

                self.$root.$emit('onLoading');

                const response = self.$store.dispatch('lead_status/all');

                response.then(function (x) {
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                });
            },
            showEdit (_status) {
                return this.showRemove(_status);
            },
            showRemove (_status) {
                if ((_status.id !== 1) && (_status.id !== 2)) {
                    return true;
                }
                
                return false;
            }
        }
    }
</script>
